<template>
  <footer>
    <a class="geogrids-slider-prev" href="#" @click.prevent="onScrollClick(-1)">
      <i class="far fa-angle-left" />
    </a>

    <div class="geogrids-slider scroll hor" ref="slider">
      <div v-for="geogrid in formattedGeogrids" :key="geogrid.id"
        :class="['geogrids-slider-item', { active: geogrid === currentGeogrid }]"
        @click.prevent="onGeogridClick($event, geogrid)">
        <GeogridPreview :ranks="geogrid.ranks" />
        <small>{{ geogrid.formattedDate }}</small>
      </div>
    </div>

    <a class="geogrids-slider-next" href="#" @click.prevent="onScrollClick(1)">
      <i class="far fa-angle-right" />
    </a>
  </footer>
</template>

<script>
import GeogridPreview from 'vue_widgets/geogrids/components/geogrid_preview'
import formatISODatetime from '../../../helpers/formatters'

export default {
  components: { GeogridPreview },
  props: {
    geogrids: { type: Array, default: () => []},
    currentGeogrid: { type: Object }
  },
  created() {
    this.formattedGeogrids = this.geogrids.map((geogrid) => ({
      ...geogrid,
      formattedDate: formatISODatetime(geogrid.createdAt, 'fullWithTZ')
    }))
  },
  methods: {
    onGeogridClick(event, geogrid) {
      if (geogrid === this.currentGeogrid) return

      event.target.scrollIntoView({ behavior: 'smooth' })
      this.$emit('changeCurrentGeogrid', geogrid)
    },
    onScrollClick(direction = 1) {
      const { slider } = this.$refs

      if (!slider) return

      const childWidth = slider.firstElementChild?.offsetWidth || 0
      const visibleChildCount = Math.floor(slider.offsetWidth / childWidth)

      slider.scrollTo({
        left: slider.scrollLeft + childWidth * visibleChildCount * direction,
        behavior: 'smooth'
      })
    }
  },
  watch: {
    geogrids: {
      handler() {
        this.$nextTick(() => {
          this.$refs.slider.scrollLeft = this.$refs.slider.scrollWidth
        })
      },
      immediate: true
    }
  }
}
</script>
